import Grid from "@mui/material/Grid";
import type { GridSize } from "@mui/material/Grid";
import { isArray } from "lodash";
import React from "react";
import { ReactChild } from "../tools/components/ReactChild";
import { isPresent } from "../util/arrayHelper";
import { gridAlignmentConverter, itemAlignmentConverter } from "./layoutHelper";

export type AlignType = "left" | "center" | "right";

export type StackProps = {
  align?: AlignType;
  spacing?: number;
  children: ReactChild;
  xs?: GridSize;
  sm?: GridSize;
  md?: GridSize;
  lg?: GridSize;
  xl?: GridSize;
};

export function Row(props: StackProps) {
  const { children, align = "left", spacing = 2, xs, sm, md, lg, xl } = props;
  const childrenItems: React.ReactElement[] = (isArray(children)
    ? children
    : [children]) as any as React.ReactElement[];

  const size: Record<string, GridSize> = {};
  if (xs !== undefined) size.xs = xs;
  if (sm !== undefined) size.sm = sm;
  if (md !== undefined) size.md = md;
  if (lg !== undefined) size.lg = lg;
  if (xl !== undefined) size.xl = xl;
  const hasSize = Object.keys(size).length > 0;

  return (
    <Grid
      container
      direction="row"
      spacing={spacing}
      alignItems={itemAlignmentConverter(align)}
      justifyContent={gridAlignmentConverter(align)}
    >
      {childrenItems.filter(isPresent).map((child, i) => {
        return (
          <Grid key={i} size={hasSize ? size : undefined}>
            {child}
          </Grid>
        );
      })}
    </Grid>
  );
}
